import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Container, Spinner } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import Swal from "sweetalert2";
import PaginateCard from "../../../components/PaginateCard";
import { getAuthMethod } from "../../../modules/helper";
import MainMenu from "../../../modules/public/mainMenu/mainMenu";
import baseUrl from "../../../modules/utility/baseUrl";
import style from "./show.module.css";
import { Link } from "react-router-dom";
import PrintLink from "../../../components/shipment/Factor/PrintLink";

function ShowPage(props) {
  const [state, setState] = useState({
    data: [],
    drivers: [],
    partsdetails: [],
    checkBoxesValue: [],
    selectedValue: [],
    id: "",
    status: "",
    answer: "",
    modalShow: false,
    driverModalShow: false,
    showNumber: 10,
    pageNumber: 1,
    active: 1,
    paginationlength: 1,
    startNumber: 0,
    selectedNumber: 0,
    selectedDriverId: 0,
    sendItem: "",
    print: false,
    itemprint: "",
    logo: "",
    loading: true,
    btnLoading: false,
    UI: "",
    count: 0,
  });

  const getData = async signal => {
    setState(cur => ({ ...cur, loading: true }));
    const datas = await getAuthMethod(
      `/totalpost/v1/agent/show?numberpage=${state.pageNumber.toString()}&numberitems=${state.showNumber.toString()}&status=${
        props.status
      }`,
      undefined,
      signal,
    );

    if (signal.aborted === false) {
      setState(cur => ({ ...cur, loading: false }));
    }

    const newCheckBox = [];

    if (datas && datas.status === 200) {
      for (let i = 0; i < datas.data.data.totalItems.length; i++) {
        newCheckBox.push(false);
      }
      setState(cur => ({
        ...cur,
        UI: datas.data.data.UI,
        data: datas.data.data.totalItems,
        drivers: datas.data.data.drivers,
        checkBoxesValue: newCheckBox,
        paginationlength: datas.data.data.number,
        startNumber: (state.pageNumber - 1) * state.showNumber + 1,
        count: datas.data.data.count,
      }));
    }
  };

  const setChecked = (value, index, id) => {
    const newCheckBox = state.checkBoxesValue;
    if (value == true) {
      state.selectedValue.push(id);
    } else if (value == false) {
      state.selectedValue = state.selectedValue.filter(item => item != id);
    }
    newCheckBox[index] = value;
    setState(cur => ({ ...cur, checkBoxesValue: newCheckBox }));
  };

  const selectAll = () => {
    const newCheckBox = [];
    const newCheckBoxValue = [];

    if (state.selectedValue.length !== state.data.length) {
      for (let i = 0; i < state.data.length; i++) {
        newCheckBox.push(true);
        newCheckBoxValue.push(state.data[i].item.id);
      }
    }
    setState(cur => ({
      ...cur,
      checkBoxesValue: newCheckBox,
      selectedValue: newCheckBoxValue,
    }));
  };

  const sendNewToDriver = () => {
    if (state.selectedValue.length > 0) {
      setDriverModalShow(true);
    } else {
      Swal.fire({ icon: "error", text: "مرسوله ای انتخاب نشده است" });
    }
  };

  const sendNewToDriverStatus = async id => {
    setState(cur => ({ ...cur, btnLoading: true }));
    const response = await getAuthMethod(
      `/agent/v1/setGroupDriver/${id}/${state.selectedValue}`,
    );
    setState(cur => ({ ...cur, btnLoading: false }));

    if (response.status == 200) {
      Swal.fire({
        title: "با موفقیت انجام شد.",
        icon: "success",
        dangerMode: false,
      }).then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire({
        title: response.data.data,
        icon: "error",
        dangerMode: true,
      });
    }
  };

  const updateNewValue = async () => {
    if (state.selectedValue.length != 0) {
      if (props.status == "ارجاع به راننده") {
        setState(cur => ({ ...cur, btnLoading: true }));

        const response = await getAuthMethod(
          `/totalpost/v1/groupUpdate?itemId=${state.selectedValue}&status=معلق`,
        );
        setState(cur => ({ ...cur, btnLoading: false }));
        if (response.status == 200) {
          Swal.fire({
            title: "با موفقیت انجام شد.",
            icon: "success",
            dangerMode: false,
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: response.data.data,
            icon: "error",
            dangerMode: true,
          });
        }
      } else if (props.status == "معلق") {
        setState(cur => ({ ...cur, btnLoading: true }));

        const response = await getAuthMethod(
          `/totalpost/v1/groupUpdate?itemId=${state.selectedValue}&status=تحویل داده شده`,
        );
        setState(cur => ({ ...cur, btnLoading: false }));

        if (response.status == 200) {
          Swal.fire({
            title: "با موفقیت انجام شد.",
            icon: "success",
            dangerMode: false,
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: response.data.data,
            icon: "error",
            dangerMode: true,
          });
        }
      }
    } else {
      Swal.fire({
        title: "مرسوله ای انتخاب نشده است",
        icon: "error",
        dangerMode: false,
      });
    }
  };

  const rememberToDriver = async () => {
    if (props.status == "ارجاع به راننده") {
      setState(cur => ({ ...cur, btnLoading: true }));

      const response = await getAuthMethod(
        `/agent/v1/setGroupDriverRemember/${state.selectedValue}`,
      );
      setState(cur => ({ ...cur, btnLoading: false }));

      if (response.status == 200) {
        Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          dangerMode: false,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: response.data.data,
          icon: "error",
          dangerMode: true,
        });
      }
    }
  };

  const sendToDriver = id => {
    setDriverModalShow(true, id);
  };

  const updateValue = async (id, shipment = {}) => {
    if (props.status == "ارجاع به راننده") {
      setState(cur => ({ ...cur, btnLoading: true }));

      const response = await getAuthMethod(
        `/totalpost/v1/update?id=${id}&status=معلق`,
      );
      setState(cur => ({ ...cur, btnLoading: false }));

      if (response.status == 200) {
        Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          dangerMode: false,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: response.data.data,
          icon: "error",
          dangerMode: true,
        });
      }
    } else if (props.status == "معلق") {
      setState(cur => ({ ...cur, btnLoading: true }));

      const response = await getAuthMethod(
        `/totalpost/v1/update?id=${id}&status=تحویل داده شده`,
      );
      setState(cur => ({ ...cur, btnLoading: false }));

      if (response.status == 200) {
        Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          dangerMode: false,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: response.data.data,
          icon: "error",
          dangerMode: true,
        });
      }
    } else if (
      (props.status == "تحویل داده شده" &&
        shipment.internal_section_id === 3) ||
      shipment.componyId === 7
    ) {
      setState(cur => ({ ...cur, btnLoading: true }));

      const response = await getAuthMethod(
        `/totalpost/v1/update?id=${id}&status=تحویل مشتری`,
      );
      setState(cur => ({ ...cur, btnLoading: false }));

      if (response.status == 200) {
        Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          dangerMode: false,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: response.data.data,
          icon: "error",
          dangerMode: true,
        });
      }
    }
  };

  const setModalShow = (value, item = null) => {
    setState(cur => ({ ...cur, modalShow: value }));

    if (item) {
      setState(cur => ({ ...cur, partsdetails: item }));
    }
  };

  const setDriverModalShow = async (value, item = false) => {
    setState(cur => ({ ...cur, driverModalShow: value }));

    if (item) {
      setState(cur => ({ ...cur, selectedNumber: item }));
    }
  };

  const setTableAction = () => {
    if (props.status !== "تحویل مشتری") {
      return <th style={{ minWidth: 140 }}>تغییر وضعیت</th>;
    }

    return <Fragment></Fragment>;
  };

  const setServiceAt = item => {
    let iconVal = "";
    if (item.Packaging != 0 && item.hasNotifRequest != 0) {
      iconVal = (
        <div className="text-center">
          <Icon.GiftFill color="orange" title="نیازمند بسته بندی" />
          <Icon.PrinterFill color="#4B1483" title="نیازمند فاکتور" />
        </div>
      );
    } else if (item.Packaging != 0 && item.hasNotifRequest == 0) {
      iconVal = (
        <div className="text-center">
          <Icon.GiftFill color="orange" title="نیازمند بسته بندی" />
        </div>
      );
    } else if (item.hasNotifRequest != 0 && item.Packaging == 0) {
      iconVal = (
        <div className="text-center">
          <Icon.PrinterFill color="#4B1483" title="نیازمند فاکتور" />
        </div>
      );
    }

    return iconVal;
  };

  const titleeee = () => {
    if (props.status === "تحویل داده شده") {
      return <h5 className="mb-0">درحال جابه جایی</h5>;
    } else if (props.status === "تحویل مشتری") {
      return <h5 className="mb-0">تحویل داده شد</h5>;
    } else {
      return <h5 className="mb-0">{props.status}</h5>;
    }
  };

  const setInputNumber = event => {
    setState(cur => ({
      ...cur,
      showNumber: event.target.value,
      pageNumber: 1,
    }));
  };

  useEffect(() => {
    setState(cur => {
      cur.pageNumber = 1;
      return cur;
    });
  }, [props?.status]);

  useEffect(() => {
    const controller = new AbortController();
    getData(controller.signal);

    return () => controller.abort();
  }, [state.pageNumber, state.showNumber, props?.status]);

  const setNewStatus = () => {
    if (props.status == "جمع آوری نشده") {
      return (
        <Button
          className="fw-bold btn_status"
          onClick={() => sendNewToDriver()}
        >
          ارجاع به راننده
        </Button>
      );
    } else if (props.status == "ارجاع به راننده") {
      if (state.btnLoading) {
        return (
          <Button className="fw-bold btn_status d-inline-block" disabled>
            <span
              className="spinner-border spinner-border-sm ml-2"
              role="status"
              aria-hidden="true"
            ></span>
            منتظر بمانید...
          </Button>
        );
      }
      return (
        <Fragment>
          <Button
            className="fw-bold btn_status d-inline-block"
            onClick={() => updateNewValue()}
          >
            ارجاع به فروشگاه
          </Button>
          <Button
            className="fw-bold btn_status d-inline-block"
            onClick={() => rememberToDriver()}
          >
            یادآوری به راننده
          </Button>
        </Fragment>
      );
    } else if (props.status == "معلق") {
      if (state.btnLoading) {
        return (
          <Button className="fw-bold btn_status d-inline-block" disabled>
            <span
              className="spinner-border spinner-border-sm ml-2"
              role="status"
              aria-hidden="true"
            ></span>
            منتظر بمانید...
          </Button>
        );
      }
      return (
        <Button
          className="fw-bold fs-6 btn_status"
          variant="success"
          onClick={() => updateNewValue()}
        >
          تحویل
        </Button>
      );
    }

    return <Fragment></Fragment>;
  };

  const setStatus = (status, id, shipment = {}) => {
    if (status == "جمع آوری نشده") {
      return (
        <td>
          <div className="mb-2">
            <Button
              className="fw-bold btn_status"
              onClick={() => sendToDriver(id)}
            >
              ارجاع به راننده
            </Button>
          </div>
        </td>
      );
    } else if (status == "ارجاع به راننده") {
      if (state.btnLoading) {
        return (
          <td>
            <Button className="fw-bold btn_status d-inline-block" disabled>
              <span
                className="spinner-border spinner-border-sm ml-2"
                role="status"
                aria-hidden="true"
              ></span>
              منتظر بمانید...
            </Button>
          </td>
        );
      }
      return (
        <td>
          <div className="mb-2">
            <Button
              className="fw-bold btn_status"
              onClick={() => updateValue(id)}
            >
              ارجاع به فروشگاه
            </Button>
          </div>
        </td>
      );
    } else if (status == "معلق") {
      if (state.btnLoading) {
        return (
          <td>
            <Button className="fw-bold btn_status d-inline-block" disabled>
              <span
                className="spinner-border spinner-border-sm ml-2"
                role="status"
                aria-hidden="true"
              ></span>
              منتظر بمانید...
            </Button>
          </td>
        );
      }
      return (
        <td>
          <div className="mb-2">
            <Button
              className="fw-bold fs-6 btn_status"
              variant="success"
              onClick={() => updateValue(id)}
            >
              تحویل
            </Button>
          </div>
        </td>
      );
    } else if (status === "تحویل داده شده") {
      if (shipment.internal_section_id === 3 || shipment.componyId === 7) {
        if (state.btnLoading) {
          return (
            <td>
              <Button className="fw-bold btn_status d-inline-block" disabled>
                <span
                  className="spinner-border spinner-border-sm ml-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                منتظر بمانید...
              </Button>
            </td>
          );
        }
        return (
          <td>
            <div className="mb-2">
              <Button
                className="fw-bold fs-6 btn_status"
                variant="success"
                onClick={() => updateValue(id, shipment)}
              >
                تحویل مشتری
              </Button>
            </div>
          </td>
        );
      }
      return <td></td>;
    }

    return <td></td>;
  };

  const modal = (
    <Fragment>
      {state.modalShow && (
        <Modal
          onHide={() => setModalShow(false)}
          show={true}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="xl"
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              لیست پارت ها
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid">
            <div className="w-100 overflow-x-scroll px-2">
              <Table striped bordered={true} className="text-center">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>شماره پارت</th>
                    <th>نوع بسته بندی</th>
                    <th>ابعاد</th>
                    <th>محتویات</th>
                    <th>وزن</th>
                    <th>وضعیت</th>
                  </tr>
                </thead>
                <tbody>
                  {state.partsdetails.map((item, index) => (
                    <tr key={index} className="align-middle">
                      <td>{index + state.startNumber}</td>
                      <td>{item.partnumber}</td>
                      <td>{item.typeId}</td>
                      <td>
                        <span>{item.width}</span>
                        <span> × </span>
                        <span>{item.length}</span>
                        <span> × </span>
                        <span>{item.height}</span>
                      </td>
                      <td>{item.shipment}</td>
                      <td>{item.weight}</td>
                      <td>{titleeee()}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn_status" onClick={() => setModalShow(false)}>
              متوجه شدم
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Fragment>
  );

  const driverModal = state.driverModalShow && (
    <Modal
      show={true}
      onHide={() => setDriverModalShow(false)}
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          لیست جمع آوران
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <div className="w-100 overflow-x-scroll px-2">
          <Table striped bordered={true} className="text-center">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>نام و نام خانوادگی</th>
                <th>شماره موبایل</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {state.drivers.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.mobile}</td>
                  <td>
                    {state.btnLoading ? (
                      <Button disabled>
                        <span
                          className="spinner-border spinner-border-sm ml-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        منتظر بمانید...
                      </Button>
                    ) : (
                      <Button onClick={() => sendNewToDriverStatus(item.id)}>
                        ارجاع به این شخص
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn_status"
          onClick={() => setDriverModalShow(false)}
        >
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const table = (
    <div className="w-100 overflow-x-auto px-2">
      <Table
        striped
        bordered={true}
        className={"text-center w-100 " + style.table}
      >
        <thead>
          <tr className="w-100">
            <th>ردیف</th>
            <th>شماره بارنامه</th>
            <th style={{ minWidth: 120 }}>ثبت کننده</th>
            <th>تاریخ</th>
            <th>نوع سرویس</th>
            <th>شرکت سرویس دهنده</th>
            <th>فرستنده</th>
            <th>گیرنده</th>
            <th>نوع پرداخت وقابل پرداخت</th>
            <th>خدمات در محل</th>
            <th>پارت</th>
            {setTableAction()}
            <th>انتخاب</th>
          </tr>
        </thead>
        <tbody>
          {state.loading === true && (
            <tr>
              <td colSpan="20">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      fontSize: "1.2rem",
                      color: "#335d45",
                    }}
                  />
                </div>
              </td>
            </tr>
          )}
          {state.loading === false && (
            <Fragment>
              {state.data.map((item, index) => (
                <tr key={index}>
                  <td>{index + state.startNumber}</td>
                  <td>
                    <PrintLink ids={[item.item.id]}>
                      {item.item.numberParcel}
                    </PrintLink>
                  </td>
                  <td>{`${item.item?.user?.name} ${item.item?.user?.family ?? ""}`}</td>
                  <td>{item.date + " " + item.time}</td>
                  <td>
                    {item.componyservice.service.name +
                      " " +
                      item.componyservice.compony_type_post.name}
                  </td>
                  <td>{item.componyservice.compony.name}</td>
                  <td>{item.address.totalAddress}</td>
                  <td>{item.getadress.totalAddress}</td>
                  <td>
                    {item.item.MethodPayment +
                      " " +
                      (item.item.realPayable + item.item.amountCOD)}
                  </td>
                  <td>{setServiceAt(item.item)}</td>
                  <td>
                    <div
                      onClick={() => setModalShow(true, item.partsdetail)}
                      title="مشاهده جزئیات فاکتور"
                      className="c-pointer"
                    >
                      <Icon.Eye color="#4B1483" />
                      <br />
                      {item.partsdetail.length}
                    </div>
                  </td>
                  {setStatus(item.item.status, item.item.id, item.item)}
                  <td className="align-middle">
                    <input
                      style={{ transform: "scale(2)" }}
                      type="checkbox"
                      checked={state.checkBoxesValue[index]}
                      onChange={e => {
                        setChecked(e.target.checked, index, item.item.id);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </Fragment>
          )}
        </tbody>
      </Table>
    </div>
  );

  const optionArew = (
    <div className="my-2">
      <Col xl={6} lg={6} md={6} sm={6}>
        <Form.Label>تعداد نمایش:</Form.Label>
        <Form.Select id="disabledSelect" onChange={setInputNumber}>
          <option>10</option>
          <option>20</option>
          <option>50</option>
          <option>100</option>
        </Form.Select>
      </Col>

      <div
        className={
          "d-flex justify-content-end align-items-center flex-wrap px-4 " +
          style.buttons
        }
      >
        <Link
          className="btn btn-warning"
          to={
            state.selectedValue.length === 0
              ? "#"
              : baseUrl +
                "/totalpost/v1/mainFactor/" +
                state.selectedValue.map(item => item)
          }
          target={state.selectedValue.length === 0 ? "" : "_blank"}
        >
          پرینت فاکتور
        </Link>

        {setNewStatus()}

        <Button className="me-auto" onClick={() => selectAll()}>
          انتخاب همه
        </Button>
      </div>
    </div>
  );

  const paginate = (
    <div className="my-3">
      <PaginateCard
        count={state.count}
        numberItems={state.showNumber}
        numberPage={state.pageNumber}
        onIndexChoose={number =>
          setState(cur => ({ ...cur, pageNumber: number }))
        }
      />
    </div>
  );

  const excelBtn = (
    <Link
      className="btn btn-success fw-bold px-2"
      download={true}
      to={`${baseUrl}/totalpost/v1/agent/show/exel/${state.UI}?status=${props.status}`}
    >
      دانلود فایل اکسل
    </Link>
  );

  const total = (
    <Container className="d-flex flex-column justify-content-center  align-items-center ">
      <Card className="w-100 my-4">
        {titleeee()}
        {optionArew}
        {table}
        {paginate}
        {modal}
        {driverModal}
        {excelBtn}
      </Card>
    </Container>
  );

  return <MainMenu data={total} />;
}

export default ShowPage;
